import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", adminCode: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // Send admin code to backend for verification (more secure)
      const res = await api.post("/Auth/admin-login", {
        email: form.email,
        password: form.password,
        adminCode: form.adminCode
      });

      // Store token
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("adminSession", "true");
      
      // Store user data for role checking across the app
      const userFromApi = res.data.user;
      const userData = {
        id: userFromApi.id,
        email: userFromApi.email,
        fullName: userFromApi.fullName,
        isAdmin: true,
        isAgent: false,
        role: "Admin"
      };
      localStorage.setItem("user", JSON.stringify(userData));
      
      console.log("Admin login successful:", userData);
      
      // Redirect to admin dashboard
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.loginCard}>
        <div style={styles.header}>
          <div style={styles.logoIcon}>🔐</div>
          <h1 style={styles.title}>Admin Portal</h1>
          <p style={styles.subtitle}>Uptech Banking Administration</p>
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Admin Email</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="Enter admin email"
              style={styles.input}
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="Enter password"
              style={styles.input}
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Admin Access Code</label>
            <input
              type="password"
              value={form.adminCode}
              onChange={(e) => setForm({ ...form, adminCode: e.target.value })}
              placeholder="Enter admin access code"
              style={styles.input}
              required
            />
            <span style={styles.hint}>Contact system administrator for access code</span>
          </div>

          <button type="submit" disabled={loading} style={styles.submitBtn}>
            {loading ? "Authenticating..." : "🔓 Access Admin Portal"}
          </button>
        </form>

        <div style={styles.footer}>
          <p style={styles.footerText}>
            Not an administrator? <a href="/user-login" style={styles.link}>Go to User Login</a>
          </p>
        </div>

        <div style={styles.securityNotice}>
          <span style={styles.securityIcon}>🛡️</span>
          <span>This is a secure area. All access attempts are logged.</span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#1a1a2e",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  },
  loginCard: {
    backgroundColor: "white",
    borderRadius: "16px",
    padding: "40px",
    width: "100%",
    maxWidth: "420px",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)"
  },
  header: {
    textAlign: "center",
    marginBottom: "30px"
  },
  logoIcon: {
    fontSize: "48px",
    marginBottom: "15px"
  },
  title: {
    margin: "0 0 8px",
    fontSize: "28px",
    fontWeight: "700",
    color: "#1a1a2e"
  },
  subtitle: {
    margin: 0,
    color: "#666",
    fontSize: "14px"
  },
  error: {
    backgroundColor: "#f8d7da",
    color: "#721c24",
    padding: "12px 15px",
    borderRadius: "8px",
    marginBottom: "20px",
    fontSize: "14px",
    textAlign: "center"
  },
  form: {},
  formGroup: {
    marginBottom: "20px"
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontSize: "13px",
    fontWeight: "600",
    color: "#333"
  },
  input: {
    width: "100%",
    padding: "14px 16px",
    border: "2px solid #e9ecef",
    borderRadius: "8px",
    fontSize: "15px",
    boxSizing: "border-box",
    transition: "border-color 0.2s"
  },
  hint: {
    display: "block",
    marginTop: "6px",
    fontSize: "11px",
    color: "#999"
  },
  submitBtn: {
    width: "100%",
    padding: "15px",
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "10px"
  },
  footer: {
    textAlign: "center",
    marginTop: "25px",
    paddingTop: "20px",
    borderTop: "1px solid #e9ecef"
  },
  footerText: {
    margin: 0,
    color: "#666",
    fontSize: "13px"
  },
  link: {
    color: "#007bff",
    textDecoration: "none",
    fontWeight: "500"
  },
  securityNotice: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    marginTop: "20px",
    padding: "12px",
    backgroundColor: "#fff3cd",
    borderRadius: "8px",
    fontSize: "11px",
    color: "#856404"
  },
  securityIcon: {
    fontSize: "14px"
  }
};
